<template>
  <router-view v-if="!queryErrorMessage" />
  <h1 v-else>{{ queryErrorMessage }}</h1>
</template>

<script>
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const query = computed(() => route.query);

    watch(query, (value) => {
      store.commit("SET_QUERY", value);
    });

    const queryErrorMessage = computed(() => {
      const { VUE_APP_QUERY_PARAMS } = process.env;
      const requiredParams = JSON.parse(VUE_APP_QUERY_PARAMS ?? "[]");
      const paramsErrorMessage = [];

      for (const requiredParam of requiredParams) {
        if (!query?.value?.[requiredParam]) {
          paramsErrorMessage.push(requiredParam);
        }
      }

      const endOfWord = paramsErrorMessage.length === 1 ? "" : "ы";

      if (paramsErrorMessage.length)
        return `Не валидная ссылка. Не передан${endOfWord} параметр${endOfWord} ${paramsErrorMessage.join(
          ", "
        )}`;

      return "";
    });

    return { query, queryErrorMessage };
  },
};
</script>

<style lang="scss">
h1 {
  text-align: center;
  font-size: 1.5em;
}
</style>
